export const version = "ethers/5.4.0";
//# sourceMappingURL=_version.js.map